module.exports = __webpack_public_path__ + "static/media/cloud-upload.2de048d6.svg";